module.exports = __webpack_public_path__ + "0d378727596c337a2280a34ea0457062.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/geel.mp3
// module id = 30
// module chunks = 0